import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../../redux/store';
import { getIncentives, payIncentive, rejectIncentive } from './incentiveMiddleware';
import { type IncentiveListResponse } from './incentiveTypes';

export const getIncentivesAction = async (
  dispatch: AppDispatch,
  payload: Record<string, string | number | undefined>
): Promise<IncentiveListResponse | null> => {
  const res = await dispatch(getIncentives(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return res.payload;
  }
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching incentives'));
  return null;
};

export const payIncentiveAction = async (
  dispatch: AppDispatch,
  payload: { id: string; onlineAmount: number; offlineAmount: number }
): Promise<boolean> => {
  const res = await dispatch(payIncentive(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Incentive paid successfully'));
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error processing payment'));
  return false;
};

export const rejectIncentiveAction = async (
  dispatch: AppDispatch,
  id: string
): Promise<boolean> => {
  const res = await dispatch(rejectIncentive({ id }));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Incentive rejected'));
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error rejecting incentive'));
  return false;
};
